import { j as c } from "../../jsx-runtime.BREq8dyb.js";
import { exceptions as q, LabeledPromise as O, testIds as H, ProgressPromise as K } from "@decentriq/utils";
import { Box as j, Button as Q } from "@mui/joy";
import { memo as W, useState as u, useCallback as X, Fragment as Y } from "react";
import Z, { PromiseState as i } from "../Loader/Loader.js";
const A = "Reprovisioning…", _ = "Reprovisioned", B = "Reprovision failed", ae = W(({
  BackButtonChildren: C = "Back",
  BackButtonProps: S,
  ControllerWrapperComponent: U = j,
  DatasetSelector: F = null,
  OkayButtonChildren: ee = "Okay",
  OkayButtonProps: re,
  onAfterReprovision: v,
  onBeforeReprovision: R,
  onError: I = () => {
  },
  reprovisionDataset: k,
  ViewWrapperComponent: $ = j
}) => {
  const [N, T] = u(void 0), [V, z] = u(void 0), [g, m] = u(void 0), [b, D] = u(!1), [G, l] = u(void 0), [J, x] = u(void 0), [h, E] = u(void 0), P = (w) => {
    x(void 0), l(A);
    const n = w();
    return n instanceof K && n.progress((p) => {
      x(Math.round(p * 100));
    }), n instanceof O && (l(n.pendingLabel || A), n.then((p) => (l(n.fulfilledLabel || _), p), void 0).catch((p) => {
      l(n.rejectedLabel || B);
    })), n;
  }, M = X(async ({
    key: w,
    manifestHash: n
  }) => {
    const y = {
      uploadArguments: {
        key: w
      },
      uploadResult: {
        manifestHash: n
      }
    };
    try {
      if (E(void 0), m(void 0), x(void 0), l(A), D(!0), Array.isArray(R) && R.length > 0)
        for (const [o, a] of R.entries())
          if (a instanceof Function) {
            const e = P(a.bind(null, y));
            let r = e?.pendingLabel, s, d = i.Pending;
            try {
              s = await e, d = i.Fulfilled, r = e?.fulfilledLabel;
            } catch (t) {
              throw d = i.Rejected, r = e?.rejectedLabel, s = t instanceof q.DatasetValidationError ? t?.report : "", t || new Error(`Unknown error: ${r}`);
            } finally {
              T((t = []) => {
                if (r || s) {
                  const L = [...t];
                  return L[o] = {
                    label: r,
                    result: s,
                    state: d
                  }, L;
                } else
                  return t;
              });
            }
          } else {
            const e = new Error(`onBeforeReprovision[${o}] is not a function`);
            throw E(null), m(e), l(B), new Error(`onBeforeReprovision[${o}] is not a function`);
          }
      const f = await P(() => {
        const o = new O(async (a, e) => {
          try {
            const r = await k(y);
            a(r);
          } catch (r) {
            e(r);
          }
        });
        return o.pendingLabel = "Provisioning dataset…", o.fulfilledLabel = "Dataset provisioned successfully", o.rejectedLabel = "Dataset provision failed", o;
      });
      if (Array.isArray(v) && v.length > 0)
        for (const [o, a] of v.entries())
          if (a instanceof Function) {
            const e = P(a.bind(null, y, f));
            let r = e?.pendingLabel, s, d = i.Pending;
            try {
              s = await e, d = i.Fulfilled, r = e?.fulfilledLabel;
            } catch (t) {
              throw d = i.Rejected, r = e?.rejectedLabel, s = t?.result, t || new Error(`Unknown error: ${r}`);
            } finally {
              z((t = []) => {
                if (r || s) {
                  const L = [...t];
                  return L[o] = {
                    label: r,
                    result: s,
                    state: d
                  }, L;
                } else
                  return t;
              });
            }
          } else {
            const e = new Error(`onAfterReprovision[${o}] is not a function`);
            throw E(null), m(e), l(B), new Error(`onAfterReprovision[${o}] is not a function`);
          }
      return E(f), l(_), f;
    } catch (f) {
      m(f), I?.(f);
    } finally {
      x(void 0), D(!1);
    }
  }, [I, v, R, k]);
  return /* @__PURE__ */ c.jsxs(Y, { children: [
    /* @__PURE__ */ c.jsx($, { sx: {
      pb: 0,
      pl: 1,
      pr: 1,
      pt: 0
    }, children: b || h || g ? /* @__PURE__ */ c.jsx(j, { sx: {
      alignItems: "center",
      display: "flex",
      height: "100%",
      justifyContent: "center"
    }, children: /* @__PURE__ */ c.jsx(Z, { LoadProgressBarAndLabelAndProgressPercentageProps: {
      sx: {
        display: "flex",
        flexDirection: "column",
        gap: "0.5rem",
        width: "clamp(0px, 16rem, 100%)"
      }
    }, LoadProgressPercentageProps: {
      sx: {
        "& .value": {
          fontSize: "inherit !important"
        }
      }
    }, loadLabel: G, loadProgress: J, loadResult: g || (h ? null : void 0), loadResults: [...N || [], ...V || []], loadState: b ? i.Pending : g ? i.Rejected : h ? i.Fulfilled : void 0 }) }) : F ? /* @__PURE__ */ c.jsx(F, { onSelect: M }) : null }),
    /* @__PURE__ */ c.jsxs(U, { sx: {
      alignItems: "center",
      display: "flex",
      flex: 0,
      justifyContent: "space-between",
      width: "100%"
    }, children: [
      !b && !h || g ? /* @__PURE__ */ c.jsx(Q, { "data-testid": H.components.dataReprovisioner.backButton, disabled: b, ...S, children: C }) : null,
      null
    ] })
  ] });
});
export {
  ae as default
};
//# sourceMappingURL=DatasetReprovisioner.js.map
